<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>首页管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/index_reco_list')">热门搜索列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='热搜词'>
            <el-input
              style="width:500px"
              v-model="filters.keywords"
              placeholder="请输入热搜词"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button v-if="hasPower('10021991')"
              type="success"
              @click="addPostDialog"
            >新增</el-button>
          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="keyName"
            label="热搜词"
          >
          </el-table-column>

          <el-table-column
            prop="infoType"
            label="放置位置"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.infoType == 2"
                type="success"
                disable-transitions
              >音视频搜索</el-tag>
              <el-tag
                v-if="scope.row.infoType == 1"
                type="info"
                disable-transitions
              >首页搜索</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="status"
            label="推荐状态"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.status == 2"
                type="success"
                disable-transitions
              >是</el-tag>
              <el-tag
                v-if="scope.row.status == 1"
                type="info"
                disable-transitions
              >否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template v-if="hasPower('10021991') && scope.row.status == 1">
                <el-button
                  @click="upHouseStatus(scope.row,2)"
                  type="text"
                  size="small"
                >推荐</el-button>
              </template>
              <template v-if="hasPower('10021991') && scope.row.status == 2">
                <el-button
                  @click="upHouseStatus(scope.row,1)"
                  type="text"
                  size="small"
                >取消</el-button>
              </template>
              <el-button v-if="hasPower('10021991')"
                @click="upHouseStatus(scope.row,3)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="新增热搜词"
      :visible.sync="dialogAddVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        ref="form"
        size='small'
        :model="form"
        :rules="addFormRule"
      >


        <el-form-item
          label="热搜词"
          prop="key_name"
        >
          <el-input
            v-model="form.key_name"
            style="width:70%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="放置位置"
          prop="info_type"
        >
          <el-select
            v-model="form.info_type"
            placeholder="请选择"
          >
            <el-option
              v-for="option in infoOptions"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="是否立即推荐"
          prop="push_status"
        >
          <el-select
            v-model="form.push_status"
            placeholder="请选择"
          >
            <el-option
              v-for="option in recoOptions"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >新增</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../bus.js";
import API from "../api/api_user";
var _ = require("lodash");
export default {
  name: "hotWord",
  created() {
    this.filters.reco_type = "1";
  },
  data() {
    return {
      addFormRule: {

        key_name: [
          { required: true, message: "请输入热搜词", trigger: "blur" }
        ],
        info_type: [
          { required: true, message: "请选择搜索放置位置", trigger: "blur" }
        ],
        push_status: [
          { required: true, message: "请选择是否立即推荐", trigger: "blur" }
        ]
      },
      addLoading: false,
      form: {
        push_status: null,
        key_name: null,
        info_type:null,
        id: null
      },
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      filters: {
        keywords: null,
        reco_type: null
      },
      isCollapse: true,
      activeName: "second",
      dialogAddVisible: false,
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      recoOptions: [
        { text: "待推荐", value: "1" },
        { text: "立即推荐", value: "2" }
      ],
      infoOptions: [
        { text: "首页搜索", value: "1" },
        { text: "音视频搜索", value: "2" }
      ],
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    beforeAvatarUpload: function(e) {},

    addPost() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          that.addLoading = true;
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          API.add_hot_word(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.dialogAddVisible = false;
                  that.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 2981) {
                  that.$message.error({
                    showClose: true,
                    message: result.message,
                    duration: 1500
                  });
                  that.addLoading = false;
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }

                that.addLoading = false;
              },
              function(err) {
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    addPostDialog() {
      this.form.pic = null;

      this.dialogAddVisible = true;
    },
    upHouseStatus(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("确定删除该推荐吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              ids: row.id,
              status: 2
            };
            API.del_hot_word(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 1) {
        let that = this;
        this.$confirm("确定取消该推荐吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.down_hot_word(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "移除成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else {
        let that = this;
        this.$confirm("确定推荐该热搜词吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.push_hot_word(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "推荐成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        page_num: that.page_num,
        page_size: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.reco_type) {
        params.reco_type = that.filters.reco_type;
      }
      if (that.filters.keywords) {
        params.keywords = that.filters.keywords;
      }
      that.loading = true;
      API.hot_word_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                // for (var i=0; i<result.list.length; i++)
                // {
                //   result.list[i].properties =
                // }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/hotWord.vue